"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tooltipVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const tooltip_module_scss_1 = __importDefault(require("./tooltip.module.scss"));
exports.tooltipVariants = ['primary', 'secondary'];
const Tooltip = ({ variant = 'primary', position = 'absolute', show, text, arrow = true, fullWidth = false, children, }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(tooltip_module_scss_1.default.container, fullWidth && tooltip_module_scss_1.default.fullWidth), children: [(0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(tooltip_module_scss_1.default.wrapper, show && tooltip_module_scss_1.default.visible, tooltip_module_scss_1.default[`variant_${variant}`], tooltip_module_scss_1.default[`position_${position}`]), children: [text, arrow && (0, jsx_runtime_1.jsx)("span", { className: tooltip_module_scss_1.default.arrow })] }), (0, jsx_runtime_1.jsx)("div", { children: children })] }));
};
exports.default = Tooltip;
